import React from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

// The "Key" strip shared by the week grid and month calendar. Items come
// from getVisibleRosterStatusLegend (only statuses actually on screen).
const RosterLegend = ({ items = [], sx }) => {
  if (items.length === 0) return null

  return (
    <Stack
      direction="row"
      gap={1}
      alignItems="center"
      flexWrap="wrap"
      sx={{
        p: 1,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        ...sx,
      }}
    >
      <Typography variant="caption" fontWeight={800} color="text.secondary">
        Key
      </Typography>
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{
            px: 0.75,
            py: 0.35,
            borderRadius: 1,
            bgcolor: item.bg,
            color: item.fg,
            border: item.dashed ? '1.5px dashed' : '1px solid',
            borderColor: item.border,
            // Availability bands for leave are hatched so they read as
            // "blocked out" next to the solid shift cards
            backgroundImage: item.hatched
              ? `repeating-linear-gradient(135deg, transparent 0 6px, ${item.border}66 6px 8px)`
              : 'none',
            animation: item.pulse
              ? 'draftRosterLegendPulse 1.25s ease-in-out infinite'
              : 'none',
            '@keyframes draftRosterLegendPulse': {
              '0%': {
                boxShadow: '0 0 0 0 rgba(35, 154, 164, 0.54)',
              },
              '70%': {
                boxShadow: '0 0 0 9px rgba(35, 154, 164, 0)',
              },
              '100%': {
                boxShadow: '0 0 0 0 rgba(35, 154, 164, 0)',
              },
            },
          }}
        >
          <Typography variant="caption" fontWeight={700} color="inherit">
            {item.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  )
}

export default RosterLegend
